<template>
    <div>
        <MultiTenant v-if="showMultiTenant"/>
        <EmailSignUpSuccess
            v-else-if="showSuccess && email"
            :email="email"
        />
        <div v-else>
            <GoogleSignInButton class="mb-4"/>
            <LinkedInSignInButton class="mb-4"/>
            <EmailSignUp  @registerSuccess="handleRegisterDone"
                          @close="showEmailSignUp = false">
            </EmailSignUp>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import EmailSignUp from './components/EmailSignUp.vue';
import EmailSignUpSuccess from './components/EmailSignUpSuccess.vue';
import { useTenant } from './composables/use-tenant';
import MultiTenant from './components/MultiTenant.vue';
import GoogleSignInButton from './components/GoogleSignInButton.vue';
import LinkedInSignInButton from './components/LinkedInSignInButton.vue';
import { useLinkedInLogin } from './composables/use-linkedin';

const { handleErrorOnLinkedLogin } = useLinkedInLogin();

const { showMultiTenant } = useTenant();

const showEmailSignUp = ref(false);
const showSuccess = ref(false);
const email = ref('');

function handleRegisterDone(form:{
    email: string,
    password: string,
    agreed: boolean,
    loading: boolean,
}) {
    email.value = form.email;
    showSuccess.value = true;
}

onMounted(() => {
    handleErrorOnLinkedLogin();
})

</script>
